module.exports = __webpack_public_path__ + "img/flag_ru.1df78b77.svg";